const fields = [
  'PDB_Vollmacht_Kunde',
  'UE_Dokumente_UebersichtsplanMitSkizzierterLIS',
  'UE_Dokumente_FotodokumentationGemVorgabe',
  'UE_Dokumente_Vollmacht',
  'UE_Dokumente_Lageplan',
  'UE_Dokumente_Leitungsplaene',
  'UE_Dokumente_Blitzschutzkonzept',
  'UE_Dokumente_GrundrissMitTechnikraum',
  'UE_Dokumente_Schnitte',
  'UE_Dokumente_Brandschutzkonzept',
  'UE_Dokumente_PlaeneAndererGewerke',
  'UE_Dokumente_Kampfmittelfreiheit',
]

const key = "Engineering Dokumente"

export const fieldOrderEngineeringDokumente = { [key]: { fields } }
export const formGroupEngineeringDokumente = {
  key,
  title: key,
  form: key,
}